<template>
  <section class="content-row cer-header">
    <div class="container">
      <header class="mncert-header">
        <h3>{{ breadcrumbs[0].title}}</h3>
        <ul class="breadcrumb">
          <li
            v-for="(item , index) in breadcrumbs[0].links"
            :key="item.name"
            :class="index === breadcrumbs[0].links.length ? 'active' : ''"
          >
            <a v-if="index+1 !== breadcrumbs[0].links.length" :href="item.path">{{ item.name }}</a>
            <span v-else>{{ item.name }}</span>
          </li>
          <!-- <li class="active">Мэдээ мэдээлэл</li> -->
        </ul>
      </header>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>